import React, { useState } from "react";
import { FaExternalLinkAlt, FaGithub } from "react-icons/fa";

const projectsData = [
  {
    id: 1,
    title: "E-Commerce Platform",
    description: "Made fullstack website for my own general store.",
    category: "fullstack",
    tag: "Full Stack",
    tech: ["React", "Node.js", "MongoDB", "Express.js"],
    image:
      "https://cdn.dribbble.com/userupload/46255962/file/0c30efe2b0c9a4fc828ccf58346ec56f.png?resize=1905x868&vertical=center",
    liveUrl: "https://www.nabinnirmalstores.com.np/",
    githubUrl: "#",
  },
  {
    id: 2,
    title: "NiraX",
    description:
      "Social media website, which demonstrate My skills to create the website using React.js",
    category: "app",
    tag: "website",
    tech: ["React"],
    image:
      "https://cdn.dribbble.com/userupload/46261299/file/8ab768cc7532b37b93d193c11306793c.png?resize=1903x872&vertical=center",
    liveUrl: "https://nerax.vercel.app/home",
    githubUrl: "https://github.com/nirmaldhakal2003/NeraX",
  },
  {
    id: 3,
    title: "social media website",
    description:
      "My first react project, i focus on how we can do crud operation rather than UI in this project. Form validation using Zod, post crud, log in log out ,routing is handled successfully!",
    category: "web",
    tag: "website",
    tech: ["JavaScript", "React"],
    image:
      "https://cdn.dribbble.com/userupload/46261353/file/be40dad180b284894f102080b47b8489.png?resize=1895x863&vertical=center",
    liveUrl: "https://nirmalsocio.vercel.app/home",
    githubUrl: "https://github.com/nirmaldhakal2003/Sociogram-Project",
  },
  {
    id: 4,
    title: "Interactive Children's learning website",
    description:
      "A website designed to make learning fun and engaging for children through interactive content and activities.",
    category: "web",
    tag: "website",
    tech: ["React", "JavaScript", "Tailwind CSS", "API"],
    image:
      "https://cdn.dribbble.com/userupload/46433267/file/2803fc602c5da3e37235779be2976541.png?resize=1900x871&vertical=center",
    liveUrl: "https://nirmall.vercel.app",
    githubUrl: "#",
  },
];

const Projects = () => {
  const [activeFilter, setActiveFilter] = useState("all");

  const filterProjects = projectsData.filter(
    (project) => activeFilter === "all" || project.category === activeFilter,
  );

  const filters = [
    { id: "all", label: "All Projects" },
    { id: "web", label: "Web Design" },
    { id: "app", label: "Web App" },
    { id: "fullstack", label: "Full Stack" },
  ];

  return (
    <section className="projects section-padding" id="projects">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            My <span>Projects</span>
          </h2>
          <p className="section-subtitle">A showcase of my recent work</p>
          <div className="section-line"></div>
        </div>

        <div className="projects-filter">
          {filters.map((filter) => (
            <button
              key={filter.id}
              className={`filter-btn ${activeFilter === filter.id ? "active" : ""}`}
              onClick={() => setActiveFilter(filter.id)}
            >
              {filter.label}
            </button>
          ))}
        </div>

        <div className="projects-grid">
          {filterProjects.map((project) => (
            <div
              className="project-card"
              key={project.id}
              data-category={project.category}
            >
              <div className="project-image">
                <img
                  src={project.image}
                  alt={project.title}
                  className="project-img"
                />
                <div className="project-overlay">
                  <div className="project-links">
                    <a
                      href={project.liveUrl}
                      className="project-link"
                      title="Live Demo"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaExternalLinkAlt />
                    </a>
                    <a
                      href={project.githubUrl}
                      className="project-link"
                      title="View Code"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaGithub />
                    </a>
                  </div>
                </div>
                <div className="project-tag">{project.tag}</div>
              </div>
              <div className="project-info">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="project-tech">
                  {project.tech.map((tech, index) => (
                    <span key={index}>{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
